import {baseApi} from "../baseApi";
import {IAddressBody, IAppDoctorTimesResponse, IAppointmentTimesResponse, ICreateAppTimesBody} from "./types";
import {IDoctorUrlParams, IGetDoctorsFilter} from "../doctor/types";

const endpoints = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAppointmentTimes: builder.query<IAppointmentTimesResponse, IDoctorUrlParams>({
            query: ({doctorId,addressId}) => ({
                url: `api/adm/appointment-times/doctor/${doctorId}/address/${addressId}`,
                method: 'GET',
            }),
            providesTags: ['appointment_times']

        }),
        getAppointmentTimesAddress: builder.query<IAppDoctorTimesResponse, IGetDoctorsFilter>({
            query: ({id, ...params}) => ({
                url: `api/adm/doctor-appointment-times/address/${id}`,
                method: 'GET',
                params:{...params}
            }),
            providesTags: ['appointment_times_address']

        }),
        createAppointmentTimesAddress: builder.mutation<IAppDoctorTimesResponse, ICreateAppTimesBody>({
            query: (body) => ({
                url: `api/adm/doctor-appointment-times/doctors/${body.doctor}`,
                method: 'POST',
                body:body
            }),
            invalidatesTags: ['appointment_times_address']

        }),

    })
})

export const {
    useGetAppointmentTimesQuery,
    useLazyGetAppointmentTimesAddressQuery,
    useCreateAppointmentTimesAddressMutation
} = endpoints